import request from "./client";

export const getNotifications = async ({ userId }) => {
  try {
    const resp = await request.get(`/v1/users/${userId}/settings/notifications`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};

export const updateNotifications = async ({ userId, payload }) => {
  try {
    const resp = await request.put(`/v1/users/${userId}/settings/notifications`).send(payload);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};
